import { render, staticRenderFns } from "./SectionItemQA.vue?vue&type=template&id=32bad1d7&scoped=true&lang=pug&"
import script from "./SectionItemQA.vue?vue&type=script&lang=js&"
export * from "./SectionItemQA.vue?vue&type=script&lang=js&"
import style0 from "./SectionItemQA.vue?vue&type=style&index=0&id=32bad1d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bad1d7",
  null
  
)

export default component.exports